<script>
import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";
import {
	getCafePage,
	updateCafePage,
} from "../../../../api/services/cms.service";
import { getS3SingedUrl } from "../../../../api/services/general.service";
import ImageCroperModel from "../../../../components/models/image-crop.vue";
/**
 * Manage General Page
 */
export default {
	page: {
		title: "Donaucafe verwalten",
		meta: [
			{
				name: "description",
				content: appConfig.description,
			},
		],
	},
	components: {
		Layout,
		PageHeader,
		"image-cropper-model": ImageCroperModel,
	},
	data() {
		return {
			title: this.$i18n.t("CMS.cafePage.mangeCafePage"),
			items: [
				{
					text: this.$i18n.t("CMS.cafePage.mangeCafePage"),
					active: true,
				},
			],
			allCafePage: null,
			cafe_title: null,
			cafe_description: null,
			cafe_title_images: null,
			cafe_slider_images: null,
			closeMessage: null,

			sliderImage_1: null,
			sliderImage_2: null,
			sliderImage_3: null,
			sliderImage_4: null,
			sliderImage_5: null,

			titleImage_1: null,
			titleImage_2: null,
			titleImage_3: null,
			titleImage_4: null,
			titleImage_5: null,

			isUpdating: false,

			sliderImageURL_1: null,
			sliderImageURL_2: null,
			sliderImageURL_3: null,
			sliderImageURL_4: null,
			sliderImageURL_5: null,

			titleImageURL_1: null,
			titleImageURL_2: null,
			titleImageURL_3: null,
			titleImageURL_4: null,
			titleImageURL_5: null,

			showSliderImageOneCropModel: false,
			sliderImageOneFileToCrop: null,
			croppedExtraImage: null,

			showSliderImageTwoCropModel: false,
			sliderImageTwoFileToCrop: null,
			croppedSliderImageTwo: null,

			showSliderImageThreeCropModel: false,
			sliderImageThreeFileToCrop: null,
			croppedSliderImageThree: null,

			showSliderImageFourCropModel: false,
			sliderImageFourFileToCrop: null,
			croppedSliderImageFour: null,

			showSliderImageFiveCropModel: false,
			sliderImageFiveFileToCrop: null,
			croppedSliderImageFive: null,

			showTitleImageOneCropModel: false,
			titleImageOneFileToCrop: null,
			croppedTitleImageOne: null,

			showTitleImageTwoCropModel: false,
			titleImageTwoFileToCrop: null,
			croppedTitleImageTwo: null,

			showTitleImageThreeCropModel: false,
			titleImageThreeFileToCrop: null,
			croppedTitleImageThree: null,

			showTitleImageFourCropModel: false,
			titleImageFourFileToCrop: null,
			croppedTitleImageFour: null,

			showTitleImageFiveCropModel: false,
			titleImageFiveFileToCrop: null,
			croppedTitleImageFive: null,
		};
	},
	validations: {
		cafe_title: { required },
		cafe_description: { required },
		closeMessage: { required },
	},
	async mounted() {
		this.getAllCafePage();
	},
	methods: {
		async getAllCafePage() {
			let getAllCafePageFuncton = await getCafePage();
			this.allCafePage = getAllCafePageFuncton[0];
			if (this.allCafePage) {
				this.cafe_title = this.allCafePage.title;
				this.cafe_description = this.allCafePage.description;
				this.cafe_title_images = this.allCafePage.titleImages;
				this.cafe_slider_images = this.allCafePage.slider_images;
				this.closeMessage = this.allCafePage.closeMessage;
			}
		},
		clickCloseButton() {
			this.$emit("reload");
		},

		async clickSaveButton() {
			this.isUpdating = true;

			// Title images
			if (this.croppedTitleImageOne) {
				const imageFile = this.$refs.titleImageOneInput.files[0];
				const croppedImage = this.croppedTitleImageOne;
				const finalImageToPass = await new Promise(function(resolve) {
					return croppedImage.toBlob(resolve, imageFile.type);
				});

				this.cafe_title_images[0] = await this.getS3PresignedUrl(
					imageFile.name,
					finalImageToPass
				);
			}
			if (this.croppedTitleImageTwo) {
				const imageFile = this.$refs.titleImageTwoInput.files[0];
				const croppedImage = this.croppedTitleImageTwo;

				const finalImageToPass = await new Promise(function(resolve) {
					return croppedImage.toBlob(resolve, imageFile.type);
				});

				this.cafe_title_images[1] = await this.getS3PresignedUrl(
					imageFile.name,
					finalImageToPass
				);
			}
			if (this.croppedTitleImageThree) {
				const imageFile = this.$refs.titleImageThreeInput.files[0];
				const croppedImage = this.croppedTitleImageThree;
				const finalImageToPass = await new Promise(function(resolve) {
					return croppedImage.toBlob(resolve, imageFile.type);
				});

				this.cafe_title_images[2] = await this.getS3PresignedUrl(
					imageFile.name,
					finalImageToPass
				);
			}
			if (this.croppedTitleImageFour) {
				const imageFile = this.$refs.titleImageFourInput.files[0];
				const croppedImage = this.croppedTitleImageFour;
				const finalImageToPass = await new Promise(function(resolve) {
					return croppedImage.toBlob(resolve, imageFile.type);
				});

				this.cafe_title_images[3] = await this.getS3PresignedUrl(
					imageFile.name,
					finalImageToPass
				);
			}
			if (this.croppedTitleImageFive) {
				const imageFile = this.$refs.titleImageFiveInput.files[0];
				const croppedImage = this.croppedTitleImageFive;
				const finalImageToPass = await new Promise(function(resolve) {
					return croppedImage.toBlob(resolve, imageFile.type);
				});

				this.cafe_title_images[4] = await this.getS3PresignedUrl(
					imageFile.name,
					finalImageToPass
				);
			}

			// SLider images
			if (this.croppedSliderImageOne) {
				const imageFile = this.$refs.extraImageInput.files[0];
				const croppedImage = this.croppedSliderImageOne;
				const finalImageToPass = await new Promise(function(resolve) {
					return croppedImage.toBlob(resolve, imageFile.type);
				});

				this.cafe_slider_images[0] = await this.getS3PresignedUrl(
					imageFile.name,
					finalImageToPass
				);
			}
			if (this.croppedSliderImageTwo) {
				const imageFile = this.$refs.sliderImageTwoInput.files[0];
				const croppedImage = this.croppedSliderImageTwo;

				const finalImageToPass = await new Promise(function(resolve) {
					return croppedImage.toBlob(resolve, imageFile.type);
				});

				this.cafe_slider_images[1] = await this.getS3PresignedUrl(
					imageFile.name,
					finalImageToPass
				);
			}
			if (this.croppedSliderImageThree) {
				const imageFile = this.$refs.sliderImageThreeInput.files[0];
				const croppedImage = this.croppedSliderImageThree;
				const finalImageToPass = await new Promise(function(resolve) {
					return croppedImage.toBlob(resolve, imageFile.type);
				});

				this.cafe_slider_images[2] = await this.getS3PresignedUrl(
					imageFile.name,
					finalImageToPass
				);
			}
			if (this.croppedSliderImageFour) {
				const imageFile = this.$refs.sliderImageFourInput.files[0];
				const croppedImage = this.croppedSliderImageFour;
				const finalImageToPass = await new Promise(function(resolve) {
					return croppedImage.toBlob(resolve, imageFile.type);
				});

				this.cafe_slider_images[3] = await this.getS3PresignedUrl(
					imageFile.name,
					finalImageToPass
				);
			}
			if (this.croppedSliderImageFive) {
				const imageFile = this.$refs.sliderImageFiveInput.files[0];
				const croppedImage = this.croppedSliderImageFive;
				const finalImageToPass = await new Promise(function(resolve) {
					return croppedImage.toBlob(resolve, imageFile.type);
				});

				this.cafe_slider_images[4] = await this.getS3PresignedUrl(
					imageFile.name,
					finalImageToPass
				);
			}

			const cafeUpdate = {
				closeMessage: this.closeMessage,
				title: this.cafe_title,
				description: this.cafe_description,
				titleImages: this.cafe_title_images,
				slider_images: this.cafe_slider_images,
			};

			await updateCafePage(this.allCafePage.id, cafeUpdate);
			this.realodPage();
		},

		// Title images

		// Title image 1
		titleImageOneSelected() {
			const imagePreviewCanvers = this.$refs.titleImageOneCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const imageFile = this.$refs.titleImageOneInput.files[0];
			this.openCropTitleImageOneModel(imageFile);
		},
		openCropTitleImageOneModel(imageFile) {
			this.titleImageOneFileToCrop = imageFile;
			this.showTitleImageOneCropModel = true;
		},
		setCroppedTitleImageOneToPreview(croppedImage) {
			const imagePreview = this.$refs.titleImageOnePreview;
			const imagePreviewCanvers = this.$refs.titleImageOneCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedTitleImageOne = croppedImage;
			this.showTitleImageOneCropModel = false;
		},
		// Title image 2
		titleImageTwoSelected() {
			const imagePreviewCanvers = this.$refs.titleImageTwoCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const imageFile = this.$refs.titleImageTwoInput.files[0];
			this.openCropTitleImageTwoModel(imageFile);
		},
		openCropTitleImageTwoModel(imageFile) {
			this.titleImageTwoFileToCrop = imageFile;
			this.showTitleImageTwoCropModel = true;
		},
		setCroppedTitleImageTwoToPreview(croppedImage) {
			const imagePreview = this.$refs.titleImageTwoPreview;
			const imagePreviewCanvers = this.$refs.titleImageTwoCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedTitleImageTwo = croppedImage;
			this.showTitleImageTwoCropModel = false;
		},

		// Title image 3
		titleImageThreeSelected() {
			const imagePreviewCanvers = this.$refs.titleImageThreeCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const imageFile = this.$refs.titleImageThreeInput.files[0];
			this.openCropTitleImageThreeModel(imageFile);
		},
		openCropTitleImageThreeModel(imageFile) {
			this.titleImageThreeFileToCrop = imageFile;
			this.showTitleImageThreeCropModel = true;
		},
		setCroppedTitleImageThreeToPreview(croppedImage) {
			const imagePreview = this.$refs.titleImageThreePreview;
			const imagePreviewCanvers = this.$refs.titleImageThreeCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedTitleImageThree = croppedImage;
			this.showTitleImageThreeCropModel = false;
		},

		// Title image 4
		titleImageFourSelected() {
			const imagePreviewCanvers = this.$refs.titleImageFourCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const imageFile = this.$refs.titleImageFourInput.files[0];
			this.openCorpTitleImageFourModel(imageFile);
		},
		openCorpTitleImageFourModel(imageFile) {
			this.titleImageFourFileToCrop = imageFile;
			this.showTitleImageFourCropModel = true;
		},
		setCroppedTitleImageFourToPreview(croppedImage) {
			const imagePreview = this.$refs.titleImageFourPreview;
			const imagePreviewCanvers = this.$refs.titleImageFourCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedTitleImageFour = croppedImage;
			this.showTitleImageFourCropModel = false;
		},

		// Title image 5
		titleImageFiveSelected() {
			const imagePreviewCanvers = this.$refs.titleImageFiveCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const imageFile = this.$refs.titleImageFiveInput.files[0];
			this.openCorpTitleImageFiveModel(imageFile);
		},
		openCorpTitleImageFiveModel(imageFile) {
			this.titleImageFiveFileToCrop = imageFile;
			this.showTitleImageFiveCropModel = true;
		},
		setCroppedTitleImageFiveToPreview(croppedImage) {
			const imagePreview = this.$refs.titleImageFivePreview;
			const imagePreviewCanvers = this.$refs.titleImageFiveCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedTitleImageFive = croppedImage;
			this.showTitleImageFiveCropModel = false;
		},

		// Image Crop
		extraImageSelected() {
			const imagePreviewCanvers = this.$refs.extraImageCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const extraImageFile = this.$refs.extraImageInput.files[0];
			this.openCorpExtraImageModel(extraImageFile);
		},
		openCorpExtraImageModel(extraImageFile) {
			this.sliderImageOneFileToCrop = extraImageFile;
			this.showSliderImageOneCropModel = true;
		},
		setCroppedImageToPreview(croppedImage) {
			const imagePreview = this.$refs.extraImagePreview;
			const imagePreviewCanvers = this.$refs.extraImageCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedSliderImageOne = croppedImage;
			this.showSliderImageOneCropModel = false;
		},

		// Slider image 2
		sliderImageTwoSelected() {
			const imagePreviewCanvers = this.$refs.sliderImageTwoCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const imageFile = this.$refs.sliderImageTwoInput.files[0];
			this.openCorpSliderImageTwoModel(imageFile);
		},
		openCorpSliderImageTwoModel(imageFile) {
			this.sliderImageTwoFileToCrop = imageFile;
			this.showSliderImageTwoCropModel = true;
		},
		setCroppedSliderImageTwoToPreview(croppedImage) {
			const imagePreview = this.$refs.sliderImageTwoPreview;
			const imagePreviewCanvers = this.$refs.sliderImageTwoCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedSliderImageTwo = croppedImage;
			this.showSliderImageTwoCropModel = false;
		},

		// Slider image 3
		sliderImageThreeSelected() {
			const imagePreviewCanvers = this.$refs.sliderImageThreeCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const imageFile = this.$refs.sliderImageThreeInput.files[0];
			this.openCorpSliderImageThreeModel(imageFile);
		},
		openCorpSliderImageThreeModel(imageFile) {
			this.sliderImageThreeFileToCrop = imageFile;
			this.showSliderImageThreeCropModel = true;
		},
		setCroppedSliderImageThreeToPreview(croppedImage) {
			const imagePreview = this.$refs.sliderImageThreePreview;
			const imagePreviewCanvers = this.$refs.sliderImageThreeCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedSliderImageThree = croppedImage;
			this.showSliderImageThreeCropModel = false;
		},

		// Slider image 4
		sliderImageFourSelected() {
			const imagePreviewCanvers = this.$refs.sliderImageFourCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const imageFile = this.$refs.sliderImageFourInput.files[0];
			this.openCorpSliderImageFourModel(imageFile);
		},
		openCorpSliderImageFourModel(imageFile) {
			this.sliderImageFourFileToCrop = imageFile;
			this.showSliderImageFourCropModel = true;
		},
		setCroppedSliderImageFourToPreview(croppedImage) {
			const imagePreview = this.$refs.sliderImageFourPreview;
			const imagePreviewCanvers = this.$refs.sliderImageFourCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedSliderImageFour = croppedImage;
			this.showSliderImageFourCropModel = false;
		},

		// Slider image 5
		sliderImageFiveSelected() {
			const imagePreviewCanvers = this.$refs.sliderImageFiveCanvas;
			const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
			imagePreviewCanversContext.clearRect(
				0,
				0,
				imagePreviewCanvers.width,
				imagePreviewCanvers.height
			);

			const imageFile = this.$refs.sliderImageFiveInput.files[0];
			this.openCorpSliderImageFiveModel(imageFile);
		},
		openCorpSliderImageFiveModel(imageFile) {
			this.sliderImageFiveFileToCrop = imageFile;
			this.showSliderImageFiveCropModel = true;
		},
		setCroppedSliderImageFiveToPreview(croppedImage) {
			const imagePreview = this.$refs.sliderImageFivePreview;
			const imagePreviewCanvers = this.$refs.sliderImageFiveCanvas;
			if (imagePreview && imagePreviewCanvers.getContext) {
				const imagePreviewCanversContext = imagePreviewCanvers.getContext("2d");
				imagePreviewCanversContext.drawImage(croppedImage, 0, 0, 120, 120);
			}
			this.croppedSliderImageFive = croppedImage;
			this.showSliderImageFiveCropModel = false;
		},

		async getS3PresignedUrl(fileName, file) {
			let getUploadedFileURL = await getS3SingedUrl(fileName);

			let getFileUploadResponse = await axios.put(
				getUploadedFileURL.signedUrl,
				file
			);

			let fileBaseUrl =
				"https://s3.eu-central-1.amazonaws.com/ms-sissi.uploads/";

			if (getFileUploadResponse) {
				return fileBaseUrl + fileName;
			}
			return null;
		},
		realodPage() {
			window.location.reload();
		},
	},
};
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<!-- Text -->
		<div class="row">
			<div class="col-md-12">
				<div class="card">
					<div class="card-body">
						<div class="card-title">
							{{ $t("CMS.cafePage.mangeCafePage") }}
						</div>
						<div class="row mt-3">
							<div class="col-md-12">
								<label>
									{{ $t("CMS.cafePage.titleLabel") }}
									<span class="text-danger">*</span>
									<span class="ml-2">
										<p
											v-if="cafe_title"
											class="badge position-absolute"
											:class="{
												'badge-light': cafe_title.length !== 30,
												'badge-danger': cafe_title.length === 30,
											}"
										>
											{{ cafe_title.length }} / 30
										</p>
									</span>
								</label>
								<b-form-group>
									<b-form-input
										v-model="cafe_title"
										:maxlength="30"
										:placeholder="this.$i18n.t('CMS.cafePage.titlePlaceholder')"
										:class="{ 'is-invalid': $v.cafe_title.$error }"
									></b-form-input>
								</b-form-group>
								<div v-if="$v.cafe_title.$error" class="invalid-feedback">
									<span
										v-if="$v.cafe_title.$error && !$v.cafe_title.required"
										>{{ $t("packages.editPackage.titleRequiredMsg") }}</span
									>
								</div>
							</div>
							<div class="col-md-12 mb-3">
								<label>
									{{ $t("CMS.cafePage.descriptionLabel") }}
									<span class="text-danger">*</span>
									<span class="ml-2">
										<p
											v-if="cafe_description"
											class="badge position-absolute"
											:class="{
												'badge-light': cafe_description.length !== 700,
												'badge-danger': cafe_description.length === 700,
											}"
										>
											{{ cafe_description.length }} / 700
										</p>
									</span>
								</label>
								<textarea
									v-model="cafe_description"
									class="form-control"
									name="textarea"
									rows="6"
									:maxlength="700"
									:placeholder="
										this.$i18n.t('CMS.cafePage.descriptionPlaceholder')
									"
									:class="{ 'is-invalid': $v.cafe_description.$error }"
								></textarea>
								<div v-if="$v.cafe_description.$error" class="invalid-feedback">
									<span
										v-if="
											$v.cafe_description.$error &&
												!$v.cafe_description.required
										"
										>{{
											$t("packages.editPackage.descriptionRequiredMsg")
										}}</span
									>
								</div>
							</div>
							<div class="col-md-12">
								<label>
									Nachricht schließen
									<span class="text-danger">*</span>
									<span class="ml-2">
										<p
											v-if="closeMessage"
											class="badge position-absolute"
											:class="{
												'badge-light': closeMessage.length !== 100,
												'badge-danger': closeMessage.length === 100,
											}"
										>
											{{ closeMessage.length }} / 100
										</p>
									</span>
								</label>
								<b-form-group>
									<b-form-input
										v-model="closeMessage"
										:maxlength="100"
										:placeholder="this.$i18n.t('CMS.cafePage.titlePlaceholder')"
										:class="{ 'is-invalid': $v.closeMessage.$error }"
									></b-form-input>
								</b-form-group>
								<div v-if="$v.closeMessage.$error" class="invalid-feedback">
									<span
										v-if="$v.closeMessage.$error && !$v.closeMessage.required"
										>{{ $t("packages.editPackage.titleRequiredMsg") }}</span
									>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Title Images -->
		<div class="row mt-3" v-if="cafe_title_images">
			<div class="col-md-12">
				<div class="card">
					<div class="card-body">
						<div class="card-title">Titel Bilder</div>

						<div class="row mt-4">
							<!-- Image 1 -->

							<div class="col-md-3 mb-4" style="height: 200px">
								<div class="avatar-md mr-4">
									<span
										ref="titleImageOnePreview"
										class="extra-image-preview-after-crop"
										:style="
											`display: ${this.croppedTitleImageOne ? '' : 'none'}`
										"
									>
										<canvas
											id="titleImageOneCanvas"
											ref="titleImageOneCanvas"
											height="200px"
											width="200px"
										></canvas>
									</span>
									<span
										v-if="!this.croppedTitleImageOne"
										style="margin-bottom: 50px; margin-top: 50px"
									>
										<img
											:src="cafe_title_images[0]"
											class="rounded-0"
											alt
											height="200px"
											width="200px"
										/>
									</span>
								</div>
							</div>
							<div class="col-md-9 mb-4">
								<div class="">
									<input
										id="titleImageOneInput"
										ref="titleImageOneInput"
										type="file"
										name="file"
										accept="image/*"
										@change="titleImageOneSelected()"
										style="width: 0.1px; opacity: 0; z-index: -1"
									/>
									<div>
										<label
											for="titleImageOneInput"
											class="text-info ml-3"
											style="cursor: pointer"
										>
											{{ $t("extras.createExtra.form.uploadNewImage") }}
										</label>
										<label class="ml-2" v-if="this.croppedExtraImage">
											&#8226;
										</label>
										<label
											class="text-info ml-2"
											@click="clickRemoveExtraImage()"
											style="cursor: pointer"
											v-if="this.croppedExtraImage"
										>
											{{ $t("extras.createExtra.form.removeImage") }}
										</label>
									</div>
									<div class="ml-3 text-mute">
										<small>
											{{ $t("extras.createExtra.form.imageSupportText") }}
											<br />
											<b> Bildgröße 500px * 500px </b>
										</small>
									</div>
								</div>
							</div>
							<!-- End -->

							<!-- Image 2 -->
							<div class="col-md-3 mb-4" style="height: 200px">
								<div class="avatar-md mr-4">
									<span
										ref="titleImageTwoPreview"
										class="extra-image-preview-after-crop"
										:style="
											`display: ${this.croppedTitleImageTwo ? '' : 'none'}`
										"
									>
										<canvas
											id="titleImageTwoCanvas"
											ref="titleImageTwoCanvas"
											height="200px"
											width="200px"
										></canvas>
									</span>
									<span
										v-if="!this.croppedTitleImageTwo"
										style="margin-bottom: 50px; margin-top: 50px"
									>
										<img
											:src="cafe_title_images[1]"
											class="rounded-0"
											alt
											height="200px"
											width="200px"
										/>
									</span>
								</div>
							</div>
							<div class="col-md-9 mb-4">
								<div class="">
									<input
										id="titleImageTwoInput"
										ref="titleImageTwoInput"
										type="file"
										name="file"
										accept="image/*"
										@change="titleImageTwoSelected()"
										style="width: 0.1px; opacity: 0; z-index: -1"
									/>
									<div>
										<label
											for="titleImageTwoInput"
											class="text-info ml-3"
											style="cursor: pointer"
										>
											{{ $t("extras.createExtra.form.uploadNewImage") }}
										</label>
										<label class="ml-2" v-if="this.croppedExtraImage">
											&#8226;
										</label>
										<label
											class="text-info ml-2"
											@click="clickRemoveExtraImage()"
											style="cursor: pointer"
											v-if="this.croppedExtraImage"
										>
											{{ $t("extras.createExtra.form.removeImage") }}
										</label>
									</div>
									<div class="ml-3 text-mute">
										<small>
											{{ $t("extras.createExtra.form.imageSupportText") }}
											<br />
											<b> Bildgröße 500px * 500px </b>
										</small>
									</div>
								</div>
							</div>
							<!-- End -->

							<!-- Image 3 -->
							<div class="col-md-3 mb-4" style="height: 200px">
								<div class="avatar-md mr-4">
									<span
										ref="titleImageThreePreview"
										class="extra-image-preview-after-crop"
										:style="
											`display: ${this.croppedTitleImageThree ? '' : 'none'}`
										"
									>
										<canvas
											id="titleImageThreeCanvas"
											ref="titleImageThreeCanvas"
											height="200px"
											width="200px"
										></canvas>
									</span>
									<span
										v-if="!this.croppedTitleImageThree"
										style="margin-bottom: 50px; margin-top: 50px"
									>
										<img
											:src="cafe_title_images[2]"
											class="rounded-0"
											alt
											height="200px"
											width="200px"
										/>
									</span>
								</div>
							</div>
							<div class="col-md-9 mb-4">
								<div class="">
									<input
										id="titleImageThreeInput"
										ref="titleImageThreeInput"
										type="file"
										name="file"
										accept="image/*"
										@change="titleImageThreeSelected()"
										style="width: 0.1px; opacity: 0; z-index: -1"
									/>
									<div>
										<label
											for="titleImageThreeInput"
											class="text-info ml-3"
											style="cursor: pointer"
										>
											{{ $t("extras.createExtra.form.uploadNewImage") }}
										</label>
										<label class="ml-2" v-if="this.croppedExtraImage">
											&#8226;
										</label>
									</div>
									<div class="ml-3 text-mute">
										<small>
											{{ $t("extras.createExtra.form.imageSupportText") }}
											<br />
											<b> Bildgröße 500px * 500px </b>
										</small>
									</div>
								</div>
							</div>
							<!-- Image 4 -->
							<div class="col-md-3 mb-4" style="height: 200px">
								<div class="avatar-md mr-4">
									<span
										ref="titleImageFourPreview"
										class="extra-image-preview-after-crop"
										:style="
											`display: ${this.croppedTitleImageFour ? '' : 'none'}`
										"
									>
										<canvas
											id="titleImageFourCanvas"
											ref="titleImageFourCanvas"
											height="200px"
											width="200px"
										></canvas>
									</span>
									<span
										v-if="!this.croppedTitleImageFour"
										style="margin-bottom: 50px; margin-top: 50px"
									>
										<img
											:src="cafe_title_images[3]"
											class="rounded-0"
											alt
											height="200px"
											width="200px"
										/>
									</span>
								</div>
							</div>
							<div class="col-md-9 mb-4">
								<div class="">
									<input
										id="titleImageFourInput"
										ref="titleImageFourInput"
										type="file"
										name="file"
										accept="image/*"
										@change="titleImageFourSelected()"
										style="width: 0.1px; opacity: 0; z-index: -1"
									/>
									<div>
										<label
											for="titleImageFourInput"
											class="text-info ml-3"
											style="cursor: pointer"
										>
											{{ $t("extras.createExtra.form.uploadNewImage") }}
										</label>
										<label class="ml-2" v-if="this.croppedExtraImage">
											&#8226;
										</label>
										<label
											class="text-info ml-2"
											@click="clickRemoveExtraImage()"
											style="cursor: pointer"
											v-if="this.croppedExtraImage"
										>
											{{ $t("extras.createExtra.form.removeImage") }}
										</label>
									</div>
									<div class="ml-3 text-mute">
										<small>
											{{ $t("extras.createExtra.form.imageSupportText") }}
											<br />
											<b> Bildgröße 500px * 500px </b>
										</small>
									</div>
								</div>
							</div>
							<!-- End -->
							<!-- Image 5 -->
							<div class="col-md-3 mb-4" style="height: 200px">
								<div class="avatar-md mr-4">
									<span
										ref="titleImageFivePreview"
										class="extra-image-preview-after-crop"
										:style="
											`display: ${this.croppedTitleImageFive ? '' : 'none'}`
										"
									>
										<canvas
											id="titleImageFiveCanvas"
											ref="titleImageFiveCanvas"
											height="200px"
											width="200px"
										></canvas>
									</span>
									<span
										v-if="!this.croppedTitleImageFive"
										style="margin-bottom: 50px; margin-top: 50px"
									>
										<img
											:src="cafe_title_images[4]"
											class="rounded-0"
											alt
											height="200px"
											width="200px"
										/>
									</span>
								</div>
							</div>
							<div class="col-md-9 mb-4">
								<div class="">
									<input
										id="titleImageFiveInput"
										ref="titleImageFiveInput"
										type="file"
										name="file"
										accept="image/*"
										@change="titleImageFiveSelected()"
										style="width: 0.1px; opacity: 0; z-index: -1"
									/>
									<div>
										<label
											for="titleImageFiveInput"
											class="text-info ml-3"
											style="cursor: pointer"
										>
											{{ $t("extras.createExtra.form.uploadNewImage") }}
										</label>
										<label class="ml-2" v-if="this.croppedExtraImage">
											&#8226;
										</label>
										<label
											class="text-info ml-2"
											@click="clickRemoveExtraImage()"
											style="cursor: pointer"
											v-if="this.croppedExtraImage"
										>
											{{ $t("extras.createExtra.form.removeImage") }}
										</label>
									</div>
									<div class="ml-3 text-mute">
										<small>
											{{ $t("extras.createExtra.form.imageSupportText") }}
											<br />
											<b> Bildgröße 500px * 500px </b>
										</small>
									</div>
								</div>
							</div>
							<!-- End -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- Slider Images -->
		<div class="row mt-3" v-if="cafe_title_images">
			<div class="col-md-12">
				<div class="card">
					<div class="card-body">
						<div class="card-title">Schieberegler-Bilder</div>
						<div class="row mt-4">
							<!-- Image 1 -->

							<div class="col-md-3 mb-4" style="height: 200px">
								<div class="avatar-md mr-4">
									<span
										ref="extraImagePreview"
										class="extra-image-preview-after-crop"
										:style="
											`display: ${this.croppedSliderImageOne ? '' : 'none'}`
										"
									>
										<canvas
											id="extraImageCanvas"
											ref="extraImageCanvas"
											height="120"
											width="120"
										></canvas
									></span>
									<span
										v-if="!this.croppedSliderImageOne"
										style="margin-bottom: 50px; margin-top: 50px"
									>
										<img
											:src="cafe_slider_images[0]"
											class="rounded-0"
											alt
											height="200"
											width="200"
										/>
									</span>
								</div>
							</div>
							<div class="col-md-9 mb-4">
								<div class="">
									<input
										id="extraImageInput"
										ref="extraImageInput"
										type="file"
										name="file"
										accept="image/*"
										@change="extraImageSelected()"
										style="width: 0.1px; opacity: 0; z-index: -1"
									/>
									<div>
										<label
											for="extraImageInput"
											class="text-info ml-3"
											style="cursor: pointer"
										>
											{{ $t("extras.createExtra.form.uploadNewImage") }}
										</label>
										<label class="ml-2" v-if="this.croppedExtraImage">
											&#8226;
										</label>
										<label
											class="text-info ml-2"
											@click="clickRemoveExtraImage()"
											style="cursor: pointer"
											v-if="this.croppedExtraImage"
										>
											{{ $t("extras.createExtra.form.removeImage") }}
										</label>
									</div>
									<div class="ml-3 text-mute">
										<small>
											{{ $t("extras.createExtra.form.imageSupportText") }}
											<br />
											<b> Bildgröße 500px * 500px </b>
										</small>
									</div>
								</div>
							</div>

							<!-- Image 2 -->
							<div class="col-md-3 mb-4" style="height: 200px">
								<div class="avatar-md mr-4">
									<span
										ref="sliderImageTwoPreview"
										class="extra-image-preview-after-crop"
										:style="
											`display: ${this.croppedSliderImageTwo ? '' : 'none'}`
										"
									>
										<canvas
											id="sliderImageTwoCanvas"
											ref="sliderImageTwoCanvas"
											height="200px"
											width="200px"
										></canvas>
									</span>
									<span
										v-if="!this.croppedSliderImageTwo"
										style="margin-bottom: 50px; margin-top: 50px"
									>
										<img
											:src="cafe_slider_images[1]"
											class="rounded-0"
											alt
											height="200px"
											width="200px"
										/>
									</span>
								</div>
							</div>
							<div class="col-md-9 mb-4">
								<div class="">
									<input
										id="sliderImageTwoInput"
										ref="sliderImageTwoInput"
										type="file"
										name="file"
										accept="image/*"
										@change="sliderImageTwoSelected()"
										style="width: 0.1px; opacity: 0; z-index: -1"
									/>
									<div>
										<label
											for="sliderImageTwoInput"
											class="text-info ml-3"
											style="cursor: pointer"
										>
											{{ $t("extras.createExtra.form.uploadNewImage") }}
										</label>
										<label class="ml-2" v-if="this.croppedExtraImage">
											&#8226;
										</label>
										<label
											class="text-info ml-2"
											@click="clickRemoveExtraImage()"
											style="cursor: pointer"
											v-if="this.croppedExtraImage"
										>
											{{ $t("extras.createExtra.form.removeImage") }}
										</label>
									</div>
									<div class="ml-3 text-mute">
										<small>
											{{ $t("extras.createExtra.form.imageSupportText") }}
											<br />
											<b> Bildgröße 500px * 500px </b>
										</small>
									</div>
								</div>
							</div>
							<!-- End -->

							<!-- Image 3 -->
							<div class="col-md-3 mb-4" style="height: 200px">
								<div class="avatar-md mr-4">
									<span
										ref="sliderImageThreePreview"
										class="extra-image-preview-after-crop"
										:style="
											`display: ${this.croppedSliderImageThree ? '' : 'none'}`
										"
									>
										<canvas
											id="sliderImageThreeCanvas"
											ref="sliderImageThreeCanvas"
											height="200px"
											width="200px"
										></canvas>
									</span>
									<span
										v-if="!this.croppedSliderImageThree"
										style="margin-bottom: 50px; margin-top: 50px"
									>
										<img
											:src="cafe_slider_images[2]"
											class="rounded-0"
											alt
											height="200px"
											width="200px"
										/>
									</span>
								</div>
							</div>
							<div class="col-md-9 mb-4">
								<div class="">
									<input
										id="sliderImageThreeInput"
										ref="sliderImageThreeInput"
										type="file"
										name="file"
										accept="image/*"
										@change="sliderImageThreeSelected()"
										style="width: 0.1px; opacity: 0; z-index: -1"
									/>
									<div>
										<label
											for="sliderImageThreeInput"
											class="text-info ml-3"
											style="cursor: pointer"
										>
											{{ $t("extras.createExtra.form.uploadNewImage") }}
										</label>
										<label class="ml-2" v-if="this.croppedExtraImage">
											&#8226;
										</label>
									</div>
									<div class="ml-3 text-mute">
										<small>
											{{ $t("extras.createExtra.form.imageSupportText") }}
											<br />
											<b> Bildgröße 500px * 500px </b>
										</small>
									</div>
								</div>
							</div>
							<!-- Image 4 -->
							<div class="col-md-3 mb-4" style="height: 200px">
								<div class="avatar-md mr-4">
									<span
										ref="sliderImageFourPreview"
										class="extra-image-preview-after-crop"
										:style="
											`display: ${this.croppedSliderImageFour ? '' : 'none'}`
										"
									>
										<canvas
											id="sliderImageFourCanvas"
											ref="sliderImageFourCanvas"
											height="200px"
											width="200px"
										></canvas>
									</span>
									<span
										v-if="!this.croppedSliderImageFour"
										style="margin-bottom: 50px; margin-top: 50px"
									>
										<img
											:src="cafe_slider_images[3]"
											class="rounded-0"
											alt
											height="200px"
											width="200px"
										/>
									</span>
								</div>
							</div>
							<div class="col-md-9 mb-4">
								<div class="">
									<input
										id="sliderImageFourInput"
										ref="sliderImageFourInput"
										type="file"
										name="file"
										accept="image/*"
										@change="sliderImageFourSelected()"
										style="width: 0.1px; opacity: 0; z-index: -1"
									/>
									<div>
										<label
											for="sliderImageFourInput"
											class="text-info ml-3"
											style="cursor: pointer"
										>
											{{ $t("extras.createExtra.form.uploadNewImage") }}
										</label>
										<label class="ml-2" v-if="this.croppedExtraImage">
											&#8226;
										</label>
										<label
											class="text-info ml-2"
											@click="clickRemoveExtraImage()"
											style="cursor: pointer"
											v-if="this.croppedExtraImage"
										>
											{{ $t("extras.createExtra.form.removeImage") }}
										</label>
									</div>
									<div class="ml-3 text-mute">
										<small>
											{{ $t("extras.createExtra.form.imageSupportText") }}
											<br />
											<b> Bildgröße 500px * 500px </b>
										</small>
									</div>
								</div>
							</div>
							<!-- End -->
							<!-- Image 5 -->
							<div class="col-md-3 mb-4" style="height: 200px">
								<div class="avatar-md mr-4">
									<span
										ref="sliderImageFivePreview"
										class="extra-image-preview-after-crop"
										:style="
											`display: ${this.croppedSliderImageFive ? '' : 'none'}`
										"
									>
										<canvas
											id="sliderImageFiveCanvas"
											ref="sliderImageFiveCanvas"
											height="200px"
											width="200px"
										></canvas>
									</span>
									<span
										v-if="!this.croppedSliderImageFive"
										style="margin-bottom: 50px; margin-top: 50px"
									>
										<img
											:src="cafe_slider_images[4]"
											class="rounded-0"
											alt
											height="200px"
											width="200px"
										/>
									</span>
								</div>
							</div>
							<div class="col-md-9 mb-4">
								<div class="">
									<input
										id="sliderImageFiveInput"
										ref="sliderImageFiveInput"
										type="file"
										name="file"
										accept="image/*"
										@change="sliderImageFiveSelected()"
										style="width: 0.1px; opacity: 0; z-index: -1"
									/>
									<div>
										<label
											for="sliderImageFiveInput"
											class="text-info ml-3"
											style="cursor: pointer"
										>
											{{ $t("extras.createExtra.form.uploadNewImage") }}
										</label>
										<label class="ml-2" v-if="this.croppedExtraImage">
											&#8226;
										</label>
										<label
											class="text-info ml-2"
											@click="clickRemoveExtraImage()"
											style="cursor: pointer"
											v-if="this.croppedExtraImage"
										>
											{{ $t("extras.createExtra.form.removeImage") }}
										</label>
									</div>
									<div class="ml-3 text-mute">
										<small>
											{{ $t("extras.createExtra.form.imageSupportText") }}
											<br />
											<b> Bildgröße 500px * 500px </b>
										</small>
									</div>
								</div>
							</div>
							<!-- End -->
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mt-3">
			<b-button
				:disabled="isUpdating"
				variant="success"
				@click="clickSaveButton()"
			>
				<i class="bx bxs-save mr-1"></i>
				{{ $t("general.buttons.save") }}</b-button
			>
		</div>
		<!-- Image Cropper Model -->
		<image-cropper-model
			v-if="this.showSliderImageOneCropModel === true"
			:visible="showSliderImageOneCropModel"
			@close="showSliderImageOneCropModel = false"
			:imageFile="sliderImageOneFileToCrop"
			@apply="setCroppedImageToPreview"
		/>
		<!-- Image Cropper Model -->
		<image-cropper-model
			v-if="this.showSliderImageTwoCropModel === true"
			:visible="showSliderImageTwoCropModel"
			@close="showSliderImageTwoCropModel = false"
			:imageFile="sliderImageTwoFileToCrop"
			@apply="setCroppedSliderImageTwoToPreview"
		/>
		<!-- Image Cropper Model -->
		<image-cropper-model
			v-if="this.showSliderImageThreeCropModel === true"
			:visible="showSliderImageThreeCropModel"
			@close="showSliderImageThreeCropModel = false"
			:imageFile="sliderImageThreeFileToCrop"
			@apply="setCroppedSliderImageThreeToPreview"
		/>

		<!-- Image Cropper Model -->
		<image-cropper-model
			v-if="this.showSliderImageFourCropModel === true"
			:visible="showSliderImageFourCropModel"
			@close="showSliderImageFourCropModel = false"
			:imageFile="sliderImageFourFileToCrop"
			@apply="setCroppedSliderImageFourToPreview"
		/>
		<!-- Image Cropper Model -->
		<image-cropper-model
			v-if="this.showSliderImageFiveCropModel === true"
			:visible="showSliderImageFiveCropModel"
			@close="showSliderImageFiveCropModel = false"
			:imageFile="sliderImageFiveFileToCrop"
			@apply="setCroppedSliderImageFiveToPreview"
		/>

		<!-- Title Image modals -->
		<!-- Image Cropper Model -->
		<image-cropper-model
			v-if="this.showTitleImageOneCropModel === true"
			:visible="showTitleImageOneCropModel"
			@close="showTitleImageOneCropModel = false"
			:imageFile="titleImageOneFileToCrop"
			@apply="setCroppedTitleImageOneToPreview"
		/>
		<!-- Image Cropper Model -->
		<image-cropper-model
			v-if="this.showTitleImageTwoCropModel === true"
			:visible="showTitleImageTwoCropModel"
			@close="showTitleImageTwoCropModel = false"
			:imageFile="titleImageTwoFileToCrop"
			@apply="setCroppedTitleImageTwoToPreview"
		/>
		<!-- Image Cropper Model -->
		<image-cropper-model
			v-if="this.showTitleImageThreeCropModel === true"
			:visible="showTitleImageThreeCropModel"
			@close="showTitleImageThreeCropModel = false"
			:imageFile="titleImageThreeFileToCrop"
			@apply="setCroppedTitleImageThreeToPreview"
		/>

		<!-- Image Cropper Model -->
		<image-cropper-model
			v-if="this.showTitleImageFourCropModel === true"
			:visible="showTitleImageFourCropModel"
			@close="showTitleImageFourCropModel = false"
			:imageFile="titleImageFourFileToCrop"
			@apply="setCroppedTitleImageFourToPreview"
		/>
		<!-- Image Cropper Model -->
		<image-cropper-model
			v-if="this.showTitleImageFiveCropModel === true"
			:visible="showTitleImageFiveCropModel"
			@close="showTitleImageFiveCropModel = false"
			:imageFile="titleImageFiveFileToCrop"
			@apply="setCroppedTitleImageFiveToPreview"
		/>
	</Layout>
</template>

<style scoped>
.text-limted-one-lines {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1; /* number of lines to show */
	-webkit-box-orient: vertical;
}
.text-limted-two-lines {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2; /* number of lines to show */
	-webkit-box-orient: vertical;
}

.extra-image-preview-after-crop {
	/* display: flex;
  justify-content: center;
  align-items: center; */
	background-color: none;
	width: 200px;
	height: 200px;
	padding: 0;
	margin: 0;
}
</style>
